exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper2[data-v-4d11c8ce]{width:100%;overflow-x:scroll;overflow-y:hidden;position:absolute;z-index:999;top:100px}#div2[data-v-4d11c8ce]{height:1px;overflow:scroll}\n", ""]);

// exports
